import Skeleton from "@/components/atoms/skeletons";

const ChartPackageSkeleton = ( ) => {
  return (
    <div className="m-chart-package-skeleton" style={{ width: '100%', height: 'fit-content', border: '1px solid #e8e8e8', borderRadius: 4, padding: 4, }}>
      <div 
        className="m-chart-package-skeleton_header" 
        style={{ 
          width: '100%', 
          display:'grid', 
          gridTemplateColumns: '80px 1fr 90px 90px',
          borderBottom: '1px solid #e8e8e8', 
          paddingBottom: 12,
          gap: 20,  
        }}
          >
        <Skeleton active loading style={{width: 80, height: 40 }} type="node"/>
        <Skeleton active loading style={{width: '100%', height: 40 }} type="node"/>
        <Skeleton active loading style={{width: 90, height: 40 }} type="node"/>
        <Skeleton active loading style={{ width: 90, height: 40 }} type="node"/>
      </div>
      <div className="m-chart-package-skeleton_chart" style={{ width: '100%', height: '100%' }}>
        <Skeleton active loading paragraph={{ rows: 20, maxWidth: 1380, fontStyle: 'justify', width: '100%'}}/>
      </div>
    </div>
  );
}

export default ChartPackageSkeleton;